<template>
  <v-flex xs12>
    <v-card raised>
      <v-container>
        <v-layout row justify-end>
          <v-btn small color="primary" v-on:click="editInstructor">Edit <v-icon right small>edit</v-icon>
          </v-btn>
          <v-btn small color="error" v-on:click="deleteInstructor">Delete <v-icon right small>delete</v-icon>
          </v-btn>
        </v-layout>
        <v-layout row align-center>
          <v-flex md3>
            <v-img max-width="200px" max-height="250px" contain :src="instructor.imageUrl"></v-img>
          </v-flex>
          <v-flex md9>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ this.fullName }}</div>
                <div>{{ this.bio }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    props: ["instructor"],
    data() {
      return {
        id: this.instructor.id,
        bio: this.instructor.bio
      };
    },
    computed: {
      fullName() {
        return this.instructor.nameFirst + " " + this.instructor.nameLast;
      }
    },
    methods: {
      editInstructor() {
        this.$store.commit("setInstructorToEdit", this.instructor);
        this.$router.push({
          path: "Instructors/Edit"
        });
      },
      deleteInstructor() {
        this.$confirm("Are you sure you want to delete this instructor?").then(res => {
          if (res) {
            this.$store.dispatch("deleteInstructor", this.instructor);
          }
        });
      }
    }
  };

</script>
